import * as locales from 'date-fns/locale'

export function getLocale() {
    const languageTag = window.noticeable.language

    if (!languageTag) {
        return locales.enUS
    }

    const chunks = languageTag.split('-')

    if (chunks.length === 2) {
        const localeLanguageWithRegion = locales[chunks[0] + chunks[1]]
        if (localeLanguageWithRegion) {
            return localeLanguageWithRegion
        }

        const localeLanguage = locales[chunks[0]]
        if (localeLanguage) {
            return localeLanguage
        }

        return locales.enUS
    } else if (chunks.length === 1) {
        const localeLanguage = locales[chunks[0]]
        if (localeLanguage) {
            return localeLanguage
        }

        return locales.enUS
    } else {
        return locales.enUS
    }
}

export function getMatchingPathPattern(): string {
    return window.noticeable.matchingPathPattern
}

export function getNewspageId(): string {
    return window.noticeable.newspageId
}

export function getPublicationElements(): NodeListOf<HTMLElement> {
    return document.querySelectorAll('.publication[data-id]')
}

export function getPublicationIds(): string[] | undefined {
    return window.noticeable.publicationIds
}

export function getProjectId(): string {
    return window.noticeable.projectId
}

export function isEmbedded(): boolean {
    return window.parent !== window.self
}

export function isPageMatching(...pathPatterns: string[]): boolean {
    return pathPatterns.includes(getMatchingPathPattern())
}
